import React, { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
const NewsDetail = lazy(() => import('./NewsDetail'))

const NewsRoutes: RouteObject[] = [
  { path: 'news-detail/:id', element: <NewsDetail /> },
]
export default NewsRoutes
